(() => {
    const items = document.querySelectorAll(".faq_main .qv .qv_item");

    const setAutoAfterTransition = (panel) => {
        const onEnd = (e) => {
            if (e.propertyName !== "height") return;
            panel.removeEventListener("transitionend", onEnd);
            // якщо панель залишилась відкрита — фіксуємо height:auto
            if (panel.closest(".qv_item")?.classList.contains("active")) {
                panel.style.height = "auto";
            }
        };
        panel.addEventListener("transitionend", onEnd);
    };

    const animateOpen = (item) => {
        const panel = item.querySelector(".qv_main");
        if (!panel) return;
        // спочатку виставляємо конкретну висоту, щоб transition спрацював
        panel.style.height = panel.scrollHeight + "px";
        setAutoAfterTransition(panel);
        item.classList.add("active");
    };

    const animateClose = (item) => {
        const panel = item.querySelector(".qv_main");
        if (!panel) return;

        // якщо було auto — зафіксуємо поточну числову висоту
        const current = panel.getBoundingClientRect().height;
        panel.style.height = current + "px";

        // перемкнемо у наступний кадр, щоб браузер “побачив” різницю
        requestAnimationFrame(() => {
            panel.style.height = "0px";
        });

        item.classList.remove("active");
    };

    const closeOthersSmooth = (except) => {
        items.forEach((it) => {
            if (it !== except) {
                const panel = it.querySelector(".qv_main");
                if (!panel) return;
                // закриваємо тільки якщо реально відкрита (має .active або висоту > 0)
                const isOpen = it.classList.contains("active") || panel.getBoundingClientRect().height > 0.5;
                if (isOpen) animateClose(it);
            }
        });
    };

    items.forEach((item, idx) => {
        const head = item.querySelector(".qv_head");
        const panel = item.querySelector(".qv_main");
        if (!head || !panel) return;

        // початковий стан
        panel.style.height = "0px";

        const toggle = () => {
            const isActive = item.classList.contains("active");
            if (isActive) {
                // плавне закриття поточного
                animateClose(item);
            } else {
                // спочатку плавно закриваємо всі інші...
                closeOthersSmooth(item);
                // ...а потім плавно відкриваємо поточний
                // (невелика пауза не потрібна, transition черги не конфліктують)
                animateOpen(item);
            }
        };

        head.addEventListener("click", toggle);
        head.setAttribute("role", "button");
        head.setAttribute("tabindex", "0");
        head.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                toggle();
            }
        });
    });

    // на ресайзі тримаємо відкриті панелі у адекватній висоті
    window.addEventListener("resize", () => {
        document.querySelectorAll(".faq_main .qv .qv_item.active .qv_main").forEach((panel) => {
            panel.style.height = "auto";
        });
    });
})();
